import { render, staticRenderFns } from "./site-dashboard.component.vue?vue&type=template&id=d215652a&scoped=true"
import script from "./site-dashboard.component.ts?vue&type=script&lang=ts&external"
export * from "./site-dashboard.component.ts?vue&type=script&lang=ts&external"
import style0 from "./site-dashboard.component.vue?vue&type=style&index=0&id=d215652a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d215652a",
  null
  
)

export default component.exports